import React, { useState } from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { HowToPlay } from './HowToPlay';
import { Faq } from './FAQ';
import { Tips } from './Tips';
import { Troubleshooting } from './Troubleshooting';
import { GhostChallenges } from './GhostChallenges';
import { SpellingLeniency } from './SpellingLeniency';
import { PageTabs } from '../../common/components/tabs/PageTabs';
import { TabPanel } from '../../common/components/tabs/TabPanel';

export const Help = () => {
  const [value, setValue] = useState(0);

  const theme = useTheme();
  const smallDisplay = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const getAllTabItems = () => [
    { index: 0, label: 'How To Play' },
    { index: 1, label: 'F.A.Q.' },
    { index: 2, label: 'Ghost Challenges' },
    { index: 3, label: 'Spelling Leniency' },
    { index: 4, label: 'Tips' },
    { index: 5, label: 'Troubleshooting' },
  ];

  return (
    <Container sx={{ mt: 5, paddingBottom: '100px' }}>
      {/* <Typography variant="h4" textAlign={'center'} letterSpacing={2} mb={2}>
        Help
      </Typography> */}
      {smallDisplay ? (
        <PageTabs
          handleTabChange={handleChange}
          orientation="horizontal"
          value={value}
          tabList={getAllTabItems()}
        />
      ) : null}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
        }}
      >
        {!smallDisplay ? (
          <PageTabs
            handleTabChange={handleChange}
            orientation="vertical"
            value={value}
            tabList={getAllTabItems()}
          />
        ) : null}
        <TabPanel value={value} index={0}>
          <HowToPlay />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Faq />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <GhostChallenges />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <SpellingLeniency />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <Tips />
        </TabPanel>
        <TabPanel value={value} index={5}>
          <Troubleshooting />
        </TabPanel>
      </Box>
    </Container>
  );
};
